import { render } from "./Peternak.vue?vue&type=template&id=36b3f6a6"
import script from "./Peternak.vue?vue&type=script&lang=js"
export * from "./Peternak.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__